export default __webpack_public_path__ + "static/menu-bg1-f389ac1433f1accc796e1a4882303c7b.png";